var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinktree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_12952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44039 3.67038L9.60977 1.44033L10.8691 2.7295L8.59414 4.89888H11.7943V6.68908H8.57843L10.8691 8.91425L9.60977 10.1785L6.5006 7.05363L3.39089 10.1785L2.13152 8.91913L4.42223 6.69396H1.20581V4.89888H4.40652L2.13152 2.73004L3.39035 1.44033L5.55973 3.67038V0.5H7.44039V3.67038ZM5.55973 9.25279H7.44039V13.5H5.55973V9.25279Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_12952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktree);
export default __webpack_public_path__ + "static/media/linktree.9734bc1fe7d54ae6b61077ea3ccade78.svg";
export { ForwardRef as ReactComponent };